import { Field } from 'formik';
import { TextInput, TextInputProps } from './TextInput';
import { Label } from '../Label/Label';
import { validateField } from '../../utils/validations';
import { FormItemError } from '../FormItemError/FormItemError';
import { getDataTest } from '../../utils/dataTests';

type Variant = 'text' | 'number' | 'price' | 'email' | 'decimal';

type Props = {
    name: string;
    label?: string;
    loading?: boolean;
    allowFieldValidation?: boolean;
    variant?: Variant;
    placeholder?: string;
    suffix?: string;
    className?: string;
    min?: number | string | null;
    max?: number | string | null;
    error?: string;
    optional?: boolean;
    readonly?: boolean;
    thousandSeparator?: string;
};

export const FormikTextInput = ({
    label,
    name,
    loading,
    error,
    allowFieldValidation,
    variant = 'text',
    optional = true,
    placeholder,
    suffix,
    max = 999999999999,
    min,
    readonly,
    thousandSeparator = ' ',
    ...props
}: Props) => {
    return (
        <div data-test={getDataTest(props)}>
            {label && <Label data-test={getDataTest(props, 'Label')}>{label}</Label>}
            <Field
                id={name}
                name={name}
                placeholder={placeholder}
                suffix={suffix}
                variant={variant}
                error={error}
                max={max}
                min={min}
                validate={(value: string | number) =>
                    (allowFieldValidation || allowFieldValidation === undefined) &&
                    validateField(value, optional, min, max, variant)
                }
            >
                {(inputProps: JSX.IntrinsicAttributes & TextInputProps) => {
                    return (
                        <TextInput
                            {...inputProps}
                            id={name}
                            key={name}
                            name={name}
                            suffix={suffix}
                            variant={variant}
                            loading={loading}
                            error={error}
                            readonly={readonly}
                            thousandSeparator={thousandSeparator}
                            data-test={getDataTest(props, 'Input')}
                        />
                    );
                }}
            </Field>
            {(error || !optional) && <FormItemError text={error} data-test={getDataTest(props, 'Error')} />}
        </div>
    );
};
